import * as React from "react";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { TopNav } from "@/components/layout/top-nav";
import { LocationPicker } from "@/components/location-picker";
import { CalculatorPanel } from "@/components/calculator-panel";

export const Route = createFileRoute("/")({
  loader: async ({ context }) => {
    if (context.auth.isSignedIn == true) {
      throw redirect({ to: "/invoices" });
    }
  },
  component: Home,
});

function Home() {
  const [step, setStep] = React.useState<"location" | "calculator">("location");
  const [skippedLocation, setSkippedLocation] = React.useState(false);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <TopNav />

      {step === "location" ? (
        <LocationPicker
          onContinue={() => setStep("calculator")}
          onSkip={() => {
            setSkippedLocation(true);
            setStep("calculator");
          }}
        />
      ) : (
        <CalculatorPanel
          skipped={skippedLocation}
          onBack={() => {
            setSkippedLocation(false);
            setStep("location");
          }}
        />
      )}
    </div>
  );
}
